// api/index.js
import request from '../util/request'

// ��¼
export function login(data) {
    return request({
        url: '/front/api/design/user/login',
        method: 'post',
        data: data,
    })
}
export function getShopByUserId(userId) {
    return request({
        url: '/front/api/design/user/getShopByUserId?userId='+userId,
        method: 'get',
    })
}
// ע��
export function register(data) {
    return request({
        url: '/front/api/design/user/register',
        method: 'post',
        data: data,
    })
}
export function updatePassword(data) {
    return request({
        url: '/front/api/design/user/updatePassword',
        method: 'post',
        data
    })
}
// 修改店铺管理
export function updateShop(data) {
    return request({
        url: '/front/api/design/shop/update',
        method: 'post',
        data: data
    })
}